<template>
  <v-data-table
    :headers="tabela.headers"
    :items="relatorio.perfis"
    :search="tabela.opcoes.pesquisa"
    :custom-filter="customFilter"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
    item-key="id"
  >
    <!-- Ordenação e Pesquisa -->
    <template v-slot:top>
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Numeração -->
    <template v-slot:[`item.numero`]="{ index }">
      <span>{{ index + 1 }}</span>
    </template>
  </v-data-table>
</template>

<script>
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { pesquisar } from '@/modules/texto';

export default {
  name: 'TabelaResultadoUnidadeProfissional',

  components: {
    AppSort,
    AppSearch,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          {
            text: 'N°',
            value: 'numero',
            width: '10%',
            sortable: false,
          },
          {
            text: 'SERVIDOR',
            value: 'servidor',
            sortable: false,
          },
          {
            text: 'CARGO',
            value: 'cargo.nome',
            sortable: false,
          },
          {
            text: 'FUNÇÃO',
            value: 'funcao.nome',
            sortable: false,
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'servidor',
          selecionado: { id: 'servidor', descricao: 'Servidor' },
          lista: [
            { id: 'servidor', descricao: 'Servidor' },
            { id: 'cargo.nome', descricao: 'Cargo' },
            { id: 'funcao.nome', descricao: 'Função' },
          ],
        },
      },
    };
  },

  methods: {
    customFilter(value, search, item) {
      return (
        pesquisar(item.servidor, search)
        || pesquisar(item.cargo ? item.cargo.nome : '', search)
        || pesquisar(item.funcao ? item.funcao.nome : '', search)
      );
    },
  },
};
</script>
